// КНОПКА «SAVE PDF» В ДОКУМЕНТЕ — окно Open шага 7 и `/r/{token}` (один `documentHtml`). Строка 67
// `3f319875cbb881c89a64cda13df7c7b5`, `s985.d1`/`s986`/`s987.d1`.
//
// ⭐ КНОПКА — ЧАСТЬ РАЗМЕТКИ ДОКУМЕНТА ТОЛЬКО ПО ОПЦИИ (`documentHtml(…, { pdf: store })`). Сервер собирает
// PDF из того же `documentHtml` без опции — кнопки в файле нет по построению, а не по CSS. В печати
// браузера её гасит `@media print`.
//
// ⭐ ЗАКРЕПЛЕНА В УГЛУ ПОВЕРХ ДОКУМЕНТА: `position:fixed` вне `.s7-doc`, поэтому не ужимается вместе со
// стопкой листов и не прокручивается. Вид — из токенов шага 7 (`.s7-cta`: амбер, `#0a0b0d`, Geist 500),
// без борда CD (`s985`: «Вид — из существующих токенов»).
//
// ⭐ ДОКУМЕНТ ПЕРЕПИСЫВАЕТСЯ (`paginateWindow` пересобирает его с планом §II) — кнопка рождается заново
// без обработчика. Поэтому `attachSaveButton` красит её по подписке на склад И опросом: новая кнопка без
// обработчика или с чужим состоянием — перекрасить. Опрос гаснет с закрытием окна.
//
// ⭐ КЛИК ДО ПОДКЛЮЧЕНИЯ НЕ ТЕРЯЕТСЯ: первый кадр уже может быть «Save PDF», а обработчик встаёт опросом
// (до `PAINT_POLL_MS` спустя). Атрибут `onclick` разметки только запоминает нажатие в окне документа
// (`QUEUED`), подключение его исполняет. Поймано e2e: нажатие сразу после открытия окна Open пропадало.

import { PDF_COPY } from './pdfCopy.js';

export const PDF_BUTTON_ID = 'lm-pdf';

/** Опрос кнопки, мс: подхватить кнопку переписанного документа. */
export const PAINT_POLL_MS = 250;

/** Флаг окна документа: нажали раньше, чем кнопку подключили. */
export const QUEUED = '__lmPdfQueued';

/** Вид кнопки по состоянию склада: до готовности — «Preparing PDF…», неактивна (s986). */
export function buttonView(status) {
  const s = status === 'ready' ? 'ready' : status === 'error' ? 'error' : 'building';
  return { state: s, text: PDF_COPY[s], disabled: s === 'building' };
}

export const SAVE_PDF_CSS = `.lm-pdf{position:fixed;z-index:20;top:calc(12px + env(safe-area-inset-top,0px));`
  + 'right:calc(12px + env(safe-area-inset-right,0px));max-width:calc(100vw - 24px);box-sizing:border-box;'
  + 'background:#D48A3C;color:#0a0b0d;border:0;padding:12px 16px;'
  + "font-family:'Geist',-apple-system,BlinkMacSystemFont,sans-serif;font-size:15px;font-weight:500;"
  + 'letter-spacing:.01em;line-height:1.2;text-align:center;cursor:pointer;box-shadow:0 2px 12px rgba(0,0,0,.45)}'
  + '.lm-pdf:hover{background:#e09a48}'
  + '.lm-pdf:focus-visible{outline:1.5px solid #E8E2D4;outline-offset:3px}'
  + '.lm-pdf[data-state=building]{opacity:.55;cursor:default}'
  + '@media print{.lm-pdf{display:none!important}}';

/** Разметка кнопки в состоянии `status` — первый кадр документа уже правильный. */
export function saveButtonHtml(status) {
  const v = buttonView(status);
  return `<button type="button" id="${PDF_BUTTON_ID}" class="lm-pdf" data-state="${v.state}"`
    + ` onclick="window.${QUEUED}=1"${v.disabled ? ' disabled aria-busy="true"' : ''}>${v.text}</button>`;
}

/** Перекрасить живую кнопку под состояние. */
export function paintButton(el, status) {
  const v = buttonView(status);
  el.dataset.state = v.state;
  el.textContent = v.text;
  el.disabled = v.disabled;
  if (v.disabled) el.setAttribute('aria-busy', 'true');
  else el.removeAttribute('aria-busy');
}

/**
 * Подключить кнопку документа окна `win` к складу. Любая ошибка доступа к окну (закрыли) — тишина.
 * @returns {() => void} отключить
 */
const BOUND = Symbol('lm-pdf-bound');

export function attachSaveButton(win, store, env = globalThis) {
  let timer = null;
  const paint = () => {
    try {
      if (win.closed) return stop();
      const el = win.document.getElementById(PDF_BUTTON_ID);
      if (!el) return undefined;
      if (el.dataset.state !== buttonView(store.status).state || !el[BOUND]) {
        paintButton(el, store.status);
        el.onclick = () => store.save(win.document);
        el[BOUND] = true;
      }
      if (win[QUEUED]) {
        win[QUEUED] = 0;
        store.save(win.document);
      }
    } catch {
      return stop();
    }
    return undefined;
  };
  const unsub = store.subscribe(paint);
  function stop() {
    unsub();
    env.clearInterval(timer);
  }
  timer = env.setInterval(paint, PAINT_POLL_MS);
  paint();
  return stop;
}
